import type React from "react";
import { ProgressBar } from "./progress-bar";

interface ContentProps {
    title: string;
    description?: string;
    currentStep: 1 | 2 | 3;
    children: React.ReactNode;
}

export const Content = ({
    title,
    description,
    currentStep,
    children,
}: ContentProps) => {
    return (
        <div className="flex flex-col gap-6">
            <div className="xs:rounded-lg bg-white xs:p-6 px-4 py-6">
                <div className="flex flex-col gap-6">
                    <ProgressBar currentStep={currentStep} />
                    <div className="flex flex-col gap-2">
                        <h2 className="font-bold text-gray-900 text-xl">
                            {title}
                        </h2>
                        {description && (
                            <p className="text-gray-600 text-sm">
                                {description}
                            </p>
                        )}
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};
